module.exports = __webpack_public_path__ + "img/rotate.38ddeeb5.svg";